module.exports = __webpack_public_path__ + "assets/logotype-big.76ca133d.svg";